<div class="plan-upgrade-dialog-wrapper bg-white min-w-[360px] max-w-[420px] w-full">
    <!-- Header -->
    <div
        class="flex items-start sm:items-center justify-between !px-5 !pt-4 sm:!pt-3 !pb-0 border-b border-slate-100 gap-3">
        <div class="flex items-center gap-2">
            <div class="flex-shrink-0 !flex !items-center !justify-center w-7 h-7 rounded-full bg-red-50 text-red-500">
                <mat-icon class="scale-90">delete_outline</mat-icon>
            </div>
            <h2 mat-dialog-title class="!m-0 !p-0 text-[16px] font-bold text-slate-800 leading-tight flex-1">
                Delete {{ data && data.type == 'team' ? 'team' : 'employee' }}?
            </h2>
        </div>
        <button mat-icon-button
            class="text-slate-400 hover:text-slate-600 transition-colors shrink-0 -mt-1 sm:mt-0 scale-[0.85]"
            (click)="closeDialog()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="dialog-content !m-0 !px-5 !pt-0 !pb-4">
        <p class="text-[14.5px] text-slate-600 !mb-2" *ngIf="data && data.type == 'team'">
            <b>{{data.name | titlecase}}</b> will be deleted.
        </p>
        <div class="text-[13.5px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" *ngIf="data && data.type == 'team'">
            Employees in this team stay in your workspace. This can't be undone.
        </div>
        <p class="text-[14.5px] text-slate-600 !mb-2" *ngIf="data && data.type != 'team'">
            <b>{{data.name | titlecase}}</b> will be removed from your workspace.
        </p>
        <div class="text-[13.5px] text-red-800 bg-red-50 border border-red-200 rounded-lg px-3 py-2" *ngIf="data && data.type != 'team'">
            This permanently deletes the employee. This can't be undone.
        </div>
    </mat-dialog-content>

    <mat-dialog-actions
        class="flex flex-col-reverse sm:flex-row w-full justify-center sm:!justify-end gap-3 pt-4 pb-2 border-t border-slate-100 mt-2 !mb-0 px-4">
        <button mat-stroked-button type="button" class="w-full sm:w-auto min-h-[40px] !m-0 rounded-lg"
            (click)="closeDialog()">
            Cancel
        </button>
        <button mat-raised-button type="button"
            class="w-full sm:w-auto min-h-[40px] !m-0 rounded-lg !bg-[#FF4D49] !text-white" (click)="deleteUser()">
            Delete {{ data && data.type == 'team' ? 'team' : 'employee' }}
        </button>
    </mat-dialog-actions>
</div>